/**
 * 59 minutes (1h token - 1 min to be safe)
 * BE allows 1h edition on files/folder current session/user created
 */
export const NODE_EDIT_EXPIRACY = 59 * 60 * 1000;
